import { createContext } from 'react';
import type { Property } from '../../interfaces';

export interface PropertiesContextProps {
  propertiesList?: Property[];

  propertiesLoading: boolean;
}

export const PropertiesContext = createContext<PropertiesContextProps | undefined>(
  undefined,
);
